import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon-o-scree-big.svg'
import _imports_1 from '@/assets/img/icon-o-close.svg'


const _hoisted_1 = { class: "aiChatBoxDialogTitle" }
const _hoisted_2 = { style: {"flex":"1","font-size":"20px","font-weight":"bold","letter-spacing":"1px"} }

import { ref, computed } from 'vue';
import 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'aiChat',
  props: {
  visible: { type: Boolean, required: true, default: false },
},
  emits: [
  'update:visible'
],
  setup(__props, { emit }) {

const props = __props;



const myIframe = ref()



const dialogShow = computed({
  get: () => props.visible,
  set: (val: boolean) => emit('update:visible', val),
});

const fullscreen = ref(false)
const fullscreenClick = () => {
  fullscreen.value = !fullscreen.value
  // nextTick(() => {
  //   requestAnimationFrame(() => {
  //     try {
  //       console.log(myIframe.value.contentDocument)
  //     } catch {
  //     }
  //   })
  // })
}

const closeClick = () => {
  dialogShow.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogShow).value = $event)),
    width: "57vw",
    "align-center": "",
    "show-fullscreen": "",
    "show-close": false,
    fullscreen: fullscreen.value,
    class: "aiChatBoxDialog",
    "close-on-click-modal": false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('aiChat.title')), 1),
        _createElementVNode("div", { class: "aiChatBoxDialogHeaderIcon" }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "pointer",
            onClick: fullscreenClick
          }),
          _createElementVNode("img", {
            src: _imports_1,
            class: "pointer",
            onClick: closeClick
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "aiChatBox",
        style: _normalizeStyle({ height: fullscreen.value ? '88vh' : '74vh' })
      }, [
        _createElementVNode("iframe", {
          ref_key: "myIframe",
          ref: myIframe,
          src: "https://dify-stag.autotollintl.com:8443/chat/gh3VwURrdJaMMtTm",
          style: {"width":"100%","height":"100%","min-height":"700px"},
          frameborder: "0",
          allow: "microphone"
        }, "\n      ", 512)
      ], 4)
    ]),
    _: 1
  }, 8, ["modelValue", "fullscreen"]))
}
}

})